import { OrganizationServiceInterface } from 'domain/services';
import { GetAllOrganizationsUserUseCaseInterface } from 'domain/usecases';

export class OrganizationService implements OrganizationServiceInterface {
  constructor(
    private readonly _getAllOrganizationsUserUseCase: GetAllOrganizationsUserUseCaseInterface,
  ) {}

  async getAllOrganizationsUser(
    params?: GetAllOrganizationsUserUseCaseInterface.Params,
  ): Promise<GetAllOrganizationsUserUseCaseInterface.Result> {
    return await this._getAllOrganizationsUserUseCase.execute(params);
  }
}
